import PropTypes from 'prop-types';
import * as React from 'react';
import { createComponent } from '../../../react/components/core/create-component.js';
import { useLegacyModalDialogContext } from './legacy.modal-dialog.context.js';
import { composeEventHandlersUtil } from '../../../react/utilities/compose-event-handlers.util.js';
import { VisuallyHidden } from '../../../react/components/visually-hidden/visually-hidden.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    visuallyHiddenLabel: PropTypes.node,
    accessibleText: PropTypes.string
};
/**
 * @deprecated Use new Modal/Dialog and its sub-components instead
 */ const LegacyModalDialogCloseButton = createComponent({
    propTypes,
    root: 'button',
    displayName: 'Button',
    propConfig: {
        derivedProps () {
            return useLegacyModalDialogContext();
        },
        processProps (props, derivedProps) {
            return _object_spread_props(_object_spread({}, props), {
                onClick: composeEventHandlersUtil(props.onClick, derivedProps.onRequestDismiss)
            });
        },
        wrapChildren ({ visuallyHiddenLabel , accessibleText  }, _derivedProps, element) {
            const accessibleNode = accessibleText !== null && accessibleText !== undefined ? accessibleText : visuallyHiddenLabel;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, accessibleNode !== null ? /*#__PURE__*/ React.createElement(VisuallyHidden, null, accessibleNode) : null, element);
        },
        classNames: [
            'swan-legacy-modal-dialog-close-button'
        ]
    }
});

export { LegacyModalDialogCloseButton };
